import React from 'react';
import { PieChart } from '@mui/x-charts';
import { Box, Typography } from '@mui/material';

const CustomPieChart = ({data, title, colours}) => {
  return (
    <Box sx={{width: "35%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px', background: '#fff'}}>
        <Typography variant="h6" component="h4" sx={{fontSize: '20px', fontWeight: 700, color: '#111'}}>
            {title}
        </Typography>
      <PieChart
        width={200}
        height={219}
        colors={colours}
        sx={{
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
        }}
        slotProps={{
        legend: {
            direction: 'horizontal',
            sx: {
                    width: '220px',
                    marginLeft: "30px",
                    minHeight: "140px",
                    maxHeight: '150px',
                    overflowY: 'auto',
                    textTransform: 'capitalize',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flexWrap: 'nowrap',
                },
            },
        }}
        series={[
        {   paddingAngle: .3,
            innerRadius: 60,
            outerRadius: 80,
            data,
            cornerRadius: 6,
        },
        ]}
      />
    </Box>
  );
};

export default CustomPieChart;